import {
  CustomFieldEntityEnum,
  ICustomFieldRecordSchema,
  IOneTimeInvoiceFormSchemaWithOfferings,
} from '@monetize/types/app';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { CustomFieldDataForm } from '../../../../components/CustomFields/CustomFieldDataForm';
import { QuoteBodyAccordion } from '../../../../components/Quotes/QuoteBodyAccordion';

export const OneTimeInvoiceAdditionalFields = ({
  value,
}: {
  value?: string;
}) => {
  const { setValue, watch } =
    useFormContext<IOneTimeInvoiceFormSchemaWithOfferings>();
  const customFields = watch('customFields') as ICustomFieldRecordSchema;

  const handleChange = useCallback(
    (value: ICustomFieldRecordSchema) =>
      setValue('customFields', value, {
        shouldDirty: true,
        shouldValidate: true,
      }),
    [setValue],
  );

  return (
    <QuoteBodyAccordion value={value} title="Additional Fields">
      <CustomFieldDataForm
        entity={CustomFieldEntityEnum.INVOICE}
        value={customFields}
        setValue={handleChange}
        mode="page"
        fieldColSpan={4}
      />
    </QuoteBodyAccordion>
  );
};
